import styled from 'styled-components';

const transparent20 = 'rgba(0, 0, 0, 0.23)';

export const LabelBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: 0;
  left: 0;
  z-index: -1;
`;

export const Label = styled.span<{ atTop?: boolean; disabled?: boolean }>`
  transition: color 0.1s ease;
  position: absolute;
  color: ${({ theme }) => theme.colors.textGrey};
  font-size: ${({ atTop }) => (atTop ? '12px' : '13px')};
  transform: ${({ atTop }) =>
    atTop ? 'translateY(-13px)' : 'translateY(12px)'};
  padding: 0 8px;
  left: 0.5rem;
  transition: transform 0.1s, font-size 0.1s;

  & > ${LabelBackground} {
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.lightestGray : theme.colors.white};
  }
`;

export const Container = styled.div<{
  $active: boolean;
  disabled: boolean;
  error: boolean;
}>`
  height: 45.5px;
  display: flex;
  border-style: solid;
  border-width: 1px;
  border-radius: 1px;
  border-color: ${({ $active, disabled, error, theme }) => {
    if (disabled) return transparent20;
    if (error) return theme.colors.red;
    return $active ? theme.colors.lightBlue : theme.colors.lightGrey;
  }};
  transition: border-color 0.1s;
  box-sizing: border-box;
  line-height: 1.1875em;
  padding: 1px;
  position: relative;

  &:hover {
    border-color: ${({ $active, disabled, error, theme }) => {
      if (disabled) return transparent20;
      if (error) return theme.colors.red;
      return $active ? theme.colors.lightBlue : theme.colors.textGrey;
    }};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.lightBlue};
  }

  &:focus-within ${Label} {
    font-size: 12px;
    transform: translateY(-13px);
  }
`;

export const InputField = styled.input<{
  disabled?: boolean;
  readOnly?: boolean;
}>`
  padding: 3px 15px;
  font-size: 14px;
  width: 100%;
  color: ${({ theme }) => theme.colors.darkBlue};
  transition: color 0.1s;

  box-sizing: content-box;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.lightestGray : 'transparent'};
  outline: 0;
  border: 0;
  cursor: ${({ disabled, readOnly }) => {
    if (!disabled) return readOnly ? 'pointer' : 'text';
    return 'default';
  }};

  &:hover {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
`;
